class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }


        
      const updatedCartTotal = parsedState.total_price;
      this.updateProgressBar(updatedCartTotal, parsedState.item_count);

        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }


updateProgressBar(cartTotal, itemCount) {
  if (typeof window.updateCartProgressBars === 'function') {
    window.updateCartProgressBars(cartTotal, itemCount);
  }
}

  
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
async function getCurrentCartForProgressBar() {
  try {
    const root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    const response = await fetch(`${root}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.warn(
      'Free shipping progress bar could not retrieve the cart.',
      error
    );

    return null;
  }
}


async function updateCartProgressBars(cartTotal, itemCount) {
  const progressWrappers =
    document.querySelectorAll('.cart-progress-wrapper');

  if (!progressWrappers.length) return;

  if (
    typeof cartTotal !== 'number' ||
    typeof itemCount !== 'number'
  ) {
    const cart = await getCurrentCartForProgressBar();

    if (!cart) return;

    cartTotal = cart.total_price;
    itemCount = cart.item_count;
  }

  progressWrappers.forEach((progressWrapper) => {
    const progressBar =
      progressWrapper.querySelector('.cart-progress-bar');

    const goalMessageElement =
      progressWrapper.querySelector('.goal-message');

    const baseThresholdUsdCents = Number(
      progressWrapper.dataset.baseThresholdUsdCents
    );

    const shopCurrency =
      progressWrapper.dataset.shopCurrency || 'USD';

    const cartCurrency =
      progressWrapper.dataset.cartCurrency || 'USD';

    const preGoalMessageTemplate =
      progressWrapper.dataset.preGoalMessageTemplate || '';

    const postGoalMessage =
      progressWrapper.dataset.postGoalMessage || '';

    if (shopCurrency !== 'USD') {
      console.warn(
        'Free shipping progress bar expects the Shopify store currency to be USD.'
      );

      progressWrapper.style.display = 'none';
      return;
    }

    let currencyRate = 1;

    if (cartCurrency !== 'USD') {
      const shopifyCurrencyRate =
        window.Shopify &&
        Shopify.currency
          ? Number(Shopify.currency.rate)
          : NaN;

      if (
        !Number.isFinite(shopifyCurrencyRate) ||
        shopifyCurrencyRate <= 0
      ) {
        console.warn(
          'Free shipping progress bar could not determine the Shopify currency conversion rate.'
        );

        progressWrapper.style.display = 'none';
        return;
      }

      currencyRate = shopifyCurrencyRate;
    }

    const progressThreshold = Math.round(
      baseThresholdUsdCents * currencyRate
    );

    if (
      itemCount === 0 ||
      cartTotal === 0 ||
      !Number.isFinite(progressThreshold) ||
      progressThreshold <= 0
    ) {
      progressWrapper.style.display = 'none';

      if (goalMessageElement) {
        goalMessageElement.style.display = 'none';
      }

      return;
    }

    progressWrapper.style.display = 'block';

    const progressPercentage = Math.min(
      Math.max((cartTotal / progressThreshold) * 100, 0),
      100
    );

    if (progressBar) {
      progressBar.style.display = 'block';
      progressBar.style.width = `${progressPercentage}%`;
    }

    if (progressPercentage >= 100) {
      progressWrapper.classList.add('full');
      progressWrapper.classList.remove('not-full');
    } else {
      progressWrapper.classList.remove('full');
      progressWrapper.classList.add('not-full');
    }

    if (!goalMessageElement) return;

    goalMessageElement.style.display = 'block';

    const remainingForGoal = Math.max(
      progressThreshold - cartTotal,
      0
    );

    const remainingAmount = remainingForGoal / 100;

    let remainingAmountFormatted;

    try {
      remainingAmountFormatted =
        new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          {
            style: 'currency',
            currency: cartCurrency
          }
        ).format(remainingAmount);
    } catch (error) {
      remainingAmountFormatted =
        `${cartCurrency} ${remainingAmount.toFixed(2)}`;
    }

    const preGoalMessage =
      preGoalMessageTemplate.replace(
        '[remainingForGoalFormatted]',
        remainingAmountFormatted
      );

    goalMessageElement.innerHTML =
      remainingForGoal > 0
        ? preGoalMessage
        : postGoalMessage;
  });
}


window.updateCartProgressBars = updateCartProgressBars;


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => updateCartProgressBars(),
    { once: true }
  );
} else {
  updateCartProgressBars();
}


let cartProgressUpdateTimer;

const cartProgressObserver = new MutationObserver((mutations) => {
  const progressBarWasAdded = mutations.some((mutation) => {
    return Array.from(mutation.addedNodes).some((node) => {
      if (!(node instanceof Element)) return false;

      return (
        node.matches('.cart-progress-wrapper') ||
        node.querySelector('.cart-progress-wrapper')
      );
    });
  });

  if (!progressBarWasAdded) return;

  clearTimeout(cartProgressUpdateTimer);

  cartProgressUpdateTimer = setTimeout(() => {
    updateCartProgressBars();
  }, 50);
});

if (document.body) {
  cartProgressObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}
customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
